import { render, staticRenderFns } from "./ElementsTextPreview.vue?vue&type=template&id=491753dc&scoped=true"
import script from "./ElementsTextPreview.vue?vue&type=script&lang=js"
export * from "./ElementsTextPreview.vue?vue&type=script&lang=js"
import style0 from "./ElementsTextPreview.vue?vue&type=style&index=0&id=491753dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491753dc",
  null
  
)

export default component.exports